import React from 'react';
import { Download } from "lucide-react";

/**
 * Exports the CostExplorer table data to a CSV file
 * @param {Object} tableData - The table data containing headers and rows
 * @param {String} filename - Optional custom filename
 */
export const exportCostExplorerDataToCsv = (tableData, filename = null) => {
  if (!tableData || !tableData.headers || !tableData.rows || tableData.rows.length === 0) {
    alert("No data to export");
    return;
  }
  
  // Generate filename with current date if not provided
  if (!filename) {
    const currentDate = new Date().toISOString().slice(0, 10);
    filename = `cost-explorer-${currentDate}.csv`;
  }
  
  // Prepare headers
  const headers = tableData.headers;
  
  // Prepare rows - each cell needs proper CSV escaping
  const rows = tableData.rows.map(row => {
    return headers.map(header => {
      let value = row[header] || '';
      
      // If value is a string with $ (currency), remove formatting for raw numbers in CSV
      if (typeof value === 'string' && value.startsWith('$')) {
        value = value.replace(/[$,]/g, '');
      }
      
      // Properly escape values for CSV format
      if (typeof value === 'string') {
        // Escape quotes by doubling them and wrap in quotes
        return `"${value.replace(/"/g, '""')}"`;
      } else {
        return value;
      }
    });
  });
  
  // Combine headers and rows into CSV content
  const csvContent = [
    headers.map(h => `"${h.replace(/"/g, '""')}"`).join(","),
    ...rows.map(row => row.join(","))
  ].join("\n");
  
  // Create and trigger download
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
  
  return true;
};

/**
 * CostExplorer Export Button component that handles the export functionality
 * @param {Object} props - Component properties
 * @param {Object} props.tableData - The table data to export
 */
const CostExplorerExport = ({ tableData }) => {
  const handleExport = () => {
    exportCostExplorerDataToCsv(tableData);
  };
  
  return (
<div className="relative group">
  <button
    className="px-3 py-1.5 border border-gray-300 rounded-md flex items-center gap-2 text-sm bg-white hover:bg-gray-50 transition-colors"
    onClick={handleExport}
    aria-label="Export data"
  >
    <Download size={16} />
  </button>
  <div 
    className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 text-xs text-white rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap"
    style={{ backgroundColor: '#003366' }}
  >
    Export as CSV
  </div>
</div>
  );
};

export default CostExplorerExport;